import React from 'react';
import Select, { SelectValue } from '../../../../Components/Base/Select/Select';
import { FieldError } from 'react-hook-form';
import useTranslation from '../../../../Hooks/useTranslation';
import IndicationLimitationCodeSelectItem from './IndicationLimitationCodeSelectItem';

export interface IndicationLimitationCodeSelectOption extends SelectValue {
	description?: string;
}

interface Props {
	options: IndicationLimitationCodeSelectOption[];
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
	valueKey?: 'id';
}

const IndicationLimitationCodeSelect: React.FC<Props> = props => {
	const { t } = useTranslation();

	const CustomOption = ({ innerProps, data, isSelected }: any) => {
		return (
			<IndicationLimitationCodeSelectItem
				item={data}
				onClick={innerProps.onClick}
				isSelected={isSelected}
			/>
		);
	};

	return (
		<Select
			{...props}
			components={{ Option: CustomOption }}
			placeholder={t('base.shared.pick')}
		/>
	);
};

export default IndicationLimitationCodeSelect;
